// extracted by mini-css-extract-plugin
export default {"savingStatusContainer":"JaI4bZ8iRcZdg7MJSLgX","savingSuccessful":"GYPIz4dIogh35Tu9Xbtm","savingFailed":"NZxv1peipf7HqJky13Ud"};